import { render, staticRenderFns } from "./e-text-ellipsis.vue?vue&type=template&id=cd581fa6&scoped=true&lang=pug"
import script from "./e-text-ellipsis.vue?vue&type=script&lang=js"
export * from "./e-text-ellipsis.vue?vue&type=script&lang=js"
import style0 from "./e-text-ellipsis.vue?vue&type=style&index=0&id=cd581fa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd581fa6",
  null
  
)

export default component.exports